import React, { useState, useRef, useEffect } from "react";
import styles from "./style.module.scss";
import ButtonIcon from "../ButtonIcon/ButtonIcon";
import CaretRight from "../../assets/svg/icons/common/CaretRight";
import CaretLeft from "../../assets/svg/icons/common/CaretLeft";
import useDomainStore from "../../stores/domain";

export default function MonthPicker({
  text = "Month Picker",
  onSubmit,
  submitText = "Submit",
  showActions = true,
  size = "medium",
  alwaysOpen = false,
  onClose,
}) {
  const { isKurvDomain } = useDomainStore();
  const currentYear = new Date().getFullYear();
  const currentMonthIndex = new Date().getMonth(); // Get current month index (0 for Jan, 1 for Feb, etc.)
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Initialize selectedMonth to the current month
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(months[currentMonthIndex]); // Set to current month
  const [isOpen, setIsOpen] = useState(false);

  const pickerRef = useRef(null);

  // Close picker when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const decreaseYear = () => setSelectedYear((prev) => prev - 1);
  const increaseYear = () => {
    if (selectedYear < currentYear) {
      setSelectedYear((prev) => prev + 1);
    }
  };

  const handleCancel = () => {
    setIsOpen(false);
    if (onClose) onClose();
  };

  const handleSubmit = () => {
    onSubmit({ year: selectedYear, month: selectedMonth });
    setIsOpen(false);
    if (onClose) onClose();
  };

  if (alwaysOpen) {
    return (
      <div className={`${styles.pickerContainer} ${styles.alwaysOpen} ${isKurvDomain ? styles.kurv_theme : ""}`}>
        <div className={styles.header}>
          <button className={styles.navBtn} onClick={decreaseYear}>
            <CaretLeft />
          </button>
          <span className={styles.year}>{selectedYear}</span>
          <button
            className={`${styles.navBtn} ${selectedYear === currentYear ? styles.disabled : ""}`}
            onClick={increaseYear}
          >
            <CaretRight />
          </button>
        </div>

        <div className={styles.monthsGrid}>
          {months.map((month) => (
            <button
              key={month}
              onClick={() => setSelectedMonth(month)}
              className={`${styles.monthBtn} ${selectedMonth === month ? styles.selected : ""}`}
            >
              {month}
            </button>
          ))}
        </div>

        {showActions && (
          <div className={styles.actions}>
            <ButtonIcon bgColor={"#EDEDF4"} onClick={handleCancel}>
              Cancel
            </ButtonIcon>
            <ButtonIcon
              bgColor={"#4C70EF"}
              textColor="#FFF"
              onClick={handleSubmit}
            >
              {submitText}
            </ButtonIcon>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={`${styles.monthPicker} ${isKurvDomain ? styles.kurv_theme : ""}`} ref={pickerRef}>
      <ButtonIcon
        size={size}
        bgColor="#EDEDF4"
        onClick={() => setIsOpen(!isOpen)}
      >
        {text}
      </ButtonIcon>

      {isOpen && (
        <div className={styles.pickerContainer}>
          <div className={styles.header}>
            <button className={styles.navBtn} onClick={decreaseYear}>
              <CaretLeft />
            </button>
            <span className={styles.year}>{selectedYear}</span>
            <button
              className={`${styles.navBtn} ${selectedYear === currentYear ? styles.disabled : ""}`}
              onClick={increaseYear}
            >
              <CaretRight />
            </button>
          </div>

          <div className={styles.monthsGrid}>
            {months.map((month) => (
              <button
                key={month}
                onClick={() => setSelectedMonth(month)}
                className={`${styles.monthBtn} ${selectedMonth === month ? styles.selected : ""}`}
              >
                {month}
              </button>
            ))}
          </div>

          {showActions && (
            <div className={styles.actions}>
              <ButtonIcon bgColor={"#EDEDF4"} onClick={handleCancel}>
                Cancel
              </ButtonIcon>
              <ButtonIcon
                bgColor={"#4C70EF"}
                textColor="#FFF"
                onClick={handleSubmit}
              >
                {submitText}
              </ButtonIcon>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
